import React from "react";
import Search from "../sidebar/Search";
import FeaturedBoards from "../sidebar/FeaturedBoards";

const HomepageSidebar = () => {
  return (
    <div>
      <section className="mb-10">
        <Search />
      </section>
      <section>
        <FeaturedBoards />
      </section>
    </div>
  );
};

export default HomepageSidebar;
